import { render, staticRenderFns } from "./BugReportModal.vue?vue&type=template&id=5a90a005&scoped=true"
import script from "./BugReportModal.vue?vue&type=script&lang=js"
export * from "./BugReportModal.vue?vue&type=script&lang=js"
import style0 from "./BugReportModal.vue?vue&type=style&index=0&id=5a90a005&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a90a005",
  null
  
)

export default component.exports